var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ol',_vm._l((_vm.content),function(stage,index){return _c('li',{key:index},[(stage.t)?[_vm._v(_vm._s(_vm.$t(stage.t)))]:[_vm._v(_vm._s(stage.name))]],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }